import useVerificationModel from "./useVerificationModel";

export { default as apiVerificationModel } from "./apiVerificationModel";
export default useVerificationModel;
